import type { ReactNode } from 'react';
import styles from './SaveBar.module.css';

/**
 * QoL §7 form layout rule 7 (R9): the form's action is always in reach — a bar that sticks to the
 * bottom of the screen while the form scrolls. `status` sits on the left (what is unsaved, what
 * is missing); the buttons on the right.
 */
export function SaveBar({ status, children }: { readonly status?: ReactNode; readonly children: ReactNode }): ReactNode {
  return (
    <div className={styles.bar} role="region" aria-label="Form actions">
      <div className={styles.status}>{status}</div>
      <div className={styles.actions}>{children}</div>
    </div>
  );
}
